import React from 'react';
import { Box, Flex, Text } from '@applatform/design-system';
import { useEnvironment } from 'context/EnvironmentContext/EnvironmentContext';
import { ReactComponent as Logo } from 'icons/zai-logo.svg';
import { ReactComponent as LogoWhite } from 'icons/zai-logo-white.svg';
import { ReactComponent as DotsRed } from './dots-red.svg';
import { SmallAndBelow } from 'components/V1/MediaQuery/MediaQuery';

function Banner() {
  const { environment } = useEnvironment();
  const isPreLiveEnv = environment === 'pre-live';
  const LogoComponent = isPreLiveEnv ? Logo : LogoWhite;

  return (
    <Box
      css={{
        position: 'relative',
        backgroundColor: isPreLiveEnv ? '$steelGrey100' : '$secondary',
        transition: 'background-color 200ms ease',
        clipPath: `polygon(
          0 0,
          100% 0,
          100% 100%,
          0 calc(100% - 9vw)
        )`,
        '@md': {
          flexGrow: 1,
          flexBasis: '40%',
          clipPath: 'none',
        },
      }}
    >
      <Flex
        css={{
          justifyContent: 'center',
          pt: '$10',
          pb: '$12',
          color: isPreLiveEnv ? '$primary' : '$white',
          transition: 'color 200ms ease',
          '@sm': { pb: '$16' },
          '@md': { mt: '336px' },
        }}
      >
        <Box>
          <SmallAndBelow>
            <Box css={{ mb: '$3', textAlign: 'center' }}>
              <LogoComponent width="112" height="44" aria-label="Zai" />
            </Box>
          </SmallAndBelow>
          <Text
            size="2xl"
            as="h1"
            css={{
              display: 'none',
              fontWeight: '$bold',
              mb: '$6',
              '@md': { display: 'block' },
            }}
          >
            Zai
          </Text>
          <Box css={{ textAlign: 'center', '@md': { textAlign: 'left' } }}>
            <Box
              css={{
                position: 'relative',
                display: 'inline-block',
              }}
            >
              <Box
                role="presentation"
                css={{
                  position: 'absolute',
                  backgroundColor: '$red700',
                  height: '12px',
                  width: '100%',
                  top: '50%',
                }}
              />
              <Text
                size="md"
                css={{
                  position: 'relative',
                  px: '$1',
                  fontWeight: '$bold',
                  textTransform: 'uppercase',
                }}
              >
                {isPreLiveEnv ? 'Pre-live' : 'Live'}
              </Text>
            </Box>
          </Box>
        </Box>
      </Flex>
      <Box
        role="presentation"
        css={{
          display: 'none',
          position: 'absolute',
          top: '-80px',
          left: '64px',
          '@md': { display: 'block' },
        }}
      >
        <DotsRed />
      </Box>
      <Box
        role="presentation"
        css={{
          display: 'none',
          position: 'absolute',
          bottom: '64px',
          right: '-80px',
          '@md': { display: 'block' },
        }}
      >
        <DotsRed />
      </Box>
    </Box>
  );
}

export default Banner;
